import React, { useEffect, useRef, useState } from 'react';
import * as roomApi from '../room-model.js';

export default function AutopilotStrip({ projectId, api = roomApi }) {
  const [enabled, setEnabled] = useState(true);
  const [actions, setActions] = useState([]);
  const mountedRef = useRef(true);
  useEffect(() => {
    mountedRef.current = true;
    api.getAutopilot(projectId).then(d => {
      if (mountedRef.current) {
        setEnabled(!!d.enabled);
        setActions(d.actions || []);
      }
    }).catch(() => {});
    return () => { mountedRef.current = false; };
  }, [projectId, api]);
  async function toggle() {
    const d = await api.setAutopilot(projectId, !enabled);
    if (mountedRef.current) setEnabled(!!d.enabled);
  }
  return (
    <div className="autopilot-strip">
      <button type="button" className={`ap-toggle ${enabled ? 'on' : 'off'}`} onClick={toggle}>
        Showrunner autopilot: {enabled ? 'ON' : 'OFF'}
      </button>
      <ul className="ap-log">
        {actions.map(a => (
          <li key={a._id} className={`ap-${a.kind}`}>
            <span className="ap-kind">{a.kind}</span> {a.agent ? <b>{a.agent}</b> : null}: {a.reason}
          </li>
        ))}
      </ul>
    </div>
  );
}
